import {Checkbox, Modal} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {CHANGE_COLUMNS} from "../store";
import {DisplayState} from "../reducers/displayReducer";
import {ColumnDefinitions} from "../constants/display-columns";

interface IProps {
    Visible: boolean
    CloseModal: () => void
}

interface IState {
    displayReducer: DisplayState
}

export default function ColumnsModal(props: IProps) {
    const selectedColumns = useSelector((state: IState) => state.displayReducer.SelectedColumns);
    const dispatch = useDispatch()

    const selectedColumnsSet = new Set(selectedColumns)

    return(
        <Modal
            visible={props.Visible}
            width="300px"
            footer={null}
            className="admin-user-details-modal"
            onCancel={props.CloseModal}
        >
            <ul style={{listStyle: 'none'}}>
                {ColumnDefinitions.map(ColumnDefinition => {
                    return <li key={ColumnDefinition.key}>
                        <Checkbox
                            checked={selectedColumnsSet.has(ColumnDefinition.key)}
                            onChange={() => dispatch({
                                type: CHANGE_COLUMNS,
                                payload: {
                                    columnKey: ColumnDefinition.key
                                }
                            })}
                        />{' '}{ColumnDefinition.key}
                    </li>
                })}
            </ul>
        </Modal>
    )
}